import {useGoogleLogin} from '@react-oauth/google'
import logo from "./images/google-logo.png"
import config from "./config.json"
import {useHttp} from "./hooks/http.hook"
import {LoaderClass} from "./elements/LoaderClass"
import React, {useContext, useState} from "react"
import {AuthContext} from "./context/AuthContext"
import {ModalWin} from "./elements/ModalWin"
import {getLocalStorageItem, logging, objectLang, setErrorWindow, setLocalStorageItem} from "./functions"

export const GoogleLoginButton = ({disabled = true, isRegistration = false, isLogin = true}) => {

    const lang = objectLang().language
    const l = lang.lang
    const auth = useContext(AuthContext)

    const [allowed, setAllowed] = useState(true)
    const [dataModal, setDataModal] = useState({})

    const {loading, request} = useHttp()

    const [deviceId] = useState(() => {
        let id = getLocalStorageItem('deviceId')

        if (!id) {
            id = crypto?.randomUUID?.() ||
                Math.random().toString(36).slice(2) + Date.now().toString(36)
            setLocalStorageItem('deviceId', id)
        }

        return id
    })

    const styleButton = {
        marginTop: "1rem",
        display: "flex",
        alignItems: "center",
        gap: "10px",
        padding: "10px 20px",
        backgroundColor: "#fff",
        border: "1px solid #ccc",
        borderRadius: "8px",
        cursor: "pointer",
        fontSize: "26px",
        fontWeight: "500",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        width: "100%"
    }

    const registerHandlerGoogle = async (email, given_name, picture) => {

        let host
        window.location.host === 'localhost:3000'
            ? host = config.localHost
            : host = config.onrender

        try {

            const data = await request(
                `${host}/api/google-drive/register`,
                'POST',
                {
                    email: btoa(email),
                    firstName: given_name,
                    nickname: '',
                    lastname: '',
                    phone: '',
                    about: '',
                    language: l,
                    avatar: picture
                })

            if (!data.isActivated && data.status === 200) {
                return window.location.replace(`/${l}/verify?uid=${data.userId}`)
            } else {

                setAllowed(false)

                setDataModal(setErrorWindow(
                    lang.modal.errors.title,
                    data.code,
                    lang.messages[`code_${data.code}`],
                    lang.modal.errors.btnOK,
                    'replaceToAuth',
                    lang.modal.errors.btnCancel,
                    'replaceToMain'
                ))
            }

        } catch (e) {
            window.location.replace(`/${l}`)
        }

        if (!email || !given_name) {

            setAllowed(false)

            const modal = {
                title: lang.modal.errors.title,
                desc: lang.messages.fillToForm,
                btnCancel: lang.modal.errors.btnCancel,
                btnOK: lang.modal.errors.btnOK,
                code: 591
            }

            setDataModal(modal)
        }
    }

    const login = useGoogleLogin({

        flow: 'auth-code',

        scope: "openid email profile https://www.googleapis.com/auth/drive",

        onSuccess: async (codeResponse) => {

            let host, isDev

            if (window.location.host === 'localhost:3000') {
                host = config.localHost
                isDev = true
            } else {
                host = config.onrender
                isDev = false
            }

            try {

                const data = await request(
                    `${host}/api/google-drive/auth-code`,
                    'POST',
                    {
                        googleCode: codeResponse.code,
                        isDev: isDev,
                        deviceId: deviceId,
                        URI: window.location.origin
                    })

                if (data.status === 200 && isLogin) {

                    if (data['newAccessToken']) auth.accessToken = data['newAccessToken']

                    if (!data.isActivated) {
                        window.location.replace(`/${l}/verify?uid=${data.userId}`)
                    } else {
                        logging(l, auth, data, deviceId)
                    }

                }
                else if (data.status === 200 && isRegistration) {

                    if (!data.isActivated) {
                        window.location.replace(`/${l}/verify?uid=${data.userId}`)
                    } else {
                        logging(l, auth, data, deviceId)
                    }

                }
                else if (data.status === 404 && data.profile && isRegistration) {

                    setLocalStorageItem('google-profile', data.profile)

                    if (data.profile['email'] && data.profile['given_name']) {

                        await registerHandlerGoogle(
                            data.profile['email'],
                            data.profile['given_name'],
                            data.profile['picture']
                        )

                    } else {

                        setAllowed(false)

                        setDataModal(setErrorWindow(
                            lang.modal.errors.title,
                            data.code,
                            lang.messages[`code_${data.code}`],
                            lang.modal.errors.btnRestore,
                            `replaceTo /${l}/restore`,
                            lang.modal.errors.btnAgain,
                            'replaceToAuth'
                        ))
                    }

                }
                else {

                    setAllowed(false)

                    setDataModal(setErrorWindow(
                        lang.modal.errors.title,
                        data.code,
                        lang.messages[`code_${data.code}`],
                        lang.modal.errors.btnOK,
                        '',
                        '',
                        'replaceToMain'
                    ))
                }

            } catch (e) {

                alert('No response from the server. Go to the main page')
                window.location.replace(`/${l}/`)
            }

            return true
        },

        onError: function () {
            alert('Login Failed! Go to the main page')
            window.location.replace(`/${l}/`)
        }
    })

    if (!allowed) {
        return (
            <>
                <button
                    onClick={() => login()}
                    style={styleButton}
                    disabled={false}
                >
                    <img src={logo} alt="Google" width="30" height="30"/>
                    {'Google'}
                </button>

                <ModalWin data={dataModal}/>
            </>
        )
    }

    return (
        <button
            onClick={() => login()}
            style={styleButton}
            disabled={disabled}
        >
            {!loading && <img src={logo} alt="Google" width="30" height="30"/>}
            {loading && <LoaderClass positon={'relative'} top={0} left={0} marginTop={1} width={2} height={2}/>}
            {'Google'}
        </button>
    )
}